import { trpc } from '@/main'
import type { RootSearch } from '@/routes/__root'

/**
 * SINGLE SOURCE of the `listJobs` rail input — used by both the `/jobs` loader prefetch and the panel
 * list read, so the prefetch and the component share ONE cache key. Previously the loader hardcoded
 * `{ q: '', isPosition: true }` while the component built `{ q: searchQueryFromUrl, isPosition: true }`,
 * so a reload on a `?q=` deep link prefetched a different key than the component read. `q` defaults to
 * `''` (root schema), so a cold load equals the old hardcoded literal. Puestos are always positions
 * (`isPosition: true`).
 */
export function jobsListInput(search: Pick<RootSearch, 'q'>) {
  return { q: search.q, isPosition: true } as const
}

export function jobsListInfiniteQueryOptions(input: ReturnType<typeof jobsListInput>) {
  return trpc.jobs.listJobs.infiniteQueryOptions(input, {
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  })
}
